export enum ETipoVistoria {
  Terceiro = 1,
  Frota = 2
}

export enum ETipoAvaliacao {
  Desmobilizacao = 1,
  VistoriaVenda = 2,
  VistoriaRotina = 3,
  VistoriaCompra = 4,
  VistoriaEntrega = 5
}

export enum ETipoAvaliacaoLabel {
  Desmobilizacao = 'Desmobilização',
  VistoriaVenda = 'Venda',
  VistoriaRotina = 'Rotina',
  VistoriaCompra = 'Compra',
  VistoriaEntrega = 'Entrega'
}

export enum ESituacaoVistoria {
  EmCadastramento = 1,
  Solicitado = 2,
  Iniciada = 3,
  AguardandoAprovacao = 4,
  Aprovado = 5,
  Reprovado = 6,
  Cancelado = 7,
  AguardandoLiberacaoDoGestor = 10,
  Reavaliacao = 11
}

export enum EStatusChecklist {
  NaoRealizado = 0,
  Aprovado = 1,
  Divergencia = 2
}

export enum EStatusOperacional {
  NaoAplica = 99,
  PT = 1,
  OperacionalA = 2,
  OperacionalB = 3,
  OperacionalC = 4,
  NaoOperacional = 5,
  Avariado = 6,
  Operacional = 7,
  OperacionalD = 8,
  Sinistrado = 9
}

export enum ESituacaoVistoriaLabel {
  EmCadastramento = 'Em Cadastramento',
  Solicitado = 'Solicitado',
  Iniciada = 'Iniciada',
  AguardandoAprovacao = 'Aguardando Aprovação',
  Aprovado = 'Aprovado',
  Reprovado = 'Reprovado',
  Cancelado = 'Cancelado',
  AguardandoAssinatura = 'Aguardando Assinatura',
  AguardandoLiberacaoDoGestor = 'Aguardando Liberação do Gestor',
  Reavaliacao = 'Reavaliação'
}

export enum EStatusNegociacao {
  EmNegociacao = 1,
  Faturado = 2
}

export enum EStatusNegociacaoLabel {
  EmNegociacao = 'Em Negociação',
  Faturado = 'Faturado'
}
